import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const CUSTOM_STYLES = {
    content: { padding: 0, width: 884, border: "none" },
};

export const StyledModalInner = styled(FlexColumn)`
    height: 510px;
    user-select: none;
`;

const StyledModalContent = styled(FlexColumn)`
    flex-grow: 1;
    min-height: 0;
`;

export const StyledModalFooter = styled(FlexRow)`
    justify-content: flex-end;
    column-gap: 8px;
    padding: 16px;
    box-sizing: border-box;
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
`;
